const GENERIC_TOP_ERROR = 'Please fix invalid fields and try again.'
function Form({
  $window,
  sync,
  inputs,
  submitForm,
}) {
  let hasAttemptedSubmission = false
  let isSubmitting = false
  let errorMessage = ''
  let rateLimitedUntil = 0

  for (const input of Object.values(inputs)) {
    input.bindToForm({
      validateInputs() {
        if (hasAttemptedSubmission) {
          validateInputs()
        }
      }
    })
  }

  return {
    ...inputs,
    isSubmitting() {
      return isSubmitting
    },
    canSubmit() {
      return !isSubmitting
          && allInputsValid()
          && rateLimitedUntil <= $window.Date.now()
    },
    getErrorMessage() {
      return errorMessage
    },
    handleSubmit,
    rateLimitSeconds,
    __proto__: Form.prototype,
  }

  function allInputsValid() {
    return Object.values(inputs).every(input => input.isValid())
  }

  function handleSubmit(event) {
    event.preventDefault()

    hasAttemptedSubmission = true
    validateInputs()

    if (allInputsValid()) {
      const vals = {}
      for (const [name, input] of Object.entries(inputs)) {
        vals[name] = input.getValue()
      }
      errorMessage = ''
      isSubmitting = true
      submitForm(vals)
        .then(res => {
          isSubmitting = false
          hasAttemptedSubmission = false
          return res
        })
        .catch(res => {
          isSubmitting = false
          errorMessage = res.status >= 500
            ? 'An unexpected error occurred. Please try again.'
            : res.status === 400
              ? GENERIC_TOP_ERROR
              : res.body.message

          if (res.body.fieldErrors) {
            for (const [name, errors] of Object.entries(res.body.fieldErrors)) {
              if (Object.hasOwn(inputs, name)) {
                inputs[name].setError(errors[0])
              }
            }
          }

          if (res.status === 429) {
            errorMessage = ''
            rateLimitedUntil = $window.Date.now() + res.body.detail.msRemaining
          }
        })
    }
  }

  function rateLimitSeconds() {
    const remainingMs = Math.max(0, rateLimitedUntil - $window.Date.now())
    if (remainingMs > 0) {
      sync()
    }
    return Math.ceil(remainingMs / 1000)
  }

  function validateInputs() {
    for (const input of Object.values(inputs)) {
      input.validate()
    }
    if (allInputsValid()) {
      errorMessage = ''
    } else {
      errorMessage = GENERIC_TOP_ERROR
    }
  }
}

Object.assign(exports, { Form })
